export const Paths = {
  HOME: '/',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_AND_CONDITIONS: '/tos-online-2023',
  REDIRECT: '/app/redirect',
  INVESTIGATE: '/app/t/:tenantId/v2/investigate',
  MONITOR: '/app/t/:tenantId/monitor',
  VIEWS: '/app/t/:tenantId',
  DEMO_MONITOR: '/demo/t/:tenantId/monitor',
  ANALYZE: '/app/t/:tenantId/analyze',
  TIME_SEARCH: '/app/t/:tenantId/time-search',
  ALERT_BOARD: '/app/t/:tenantId/alerts',
  MANAGE_ALERTS: '/app/t/:tenantId/alert-manager',
  MANAGE_LIMITS: '/app/t/:tenantId/limits',
  MANAGE: '/app/t/:tenantId/manage',
  DEMO_ANALYZE: '/demo/t/:tenantId/analyze',
  SHARE: '/app/t/:tenantId/:hash',
  COLLECTION_SHARE: '/app/t/:tenantId/c/:hash',
  VIEWS_V2: '/app/t/:tenantId/views',
  MANAGE_V2_MONITOR: '/app/t/:tenantId/manage/monitor',
  MANAGE_V2_ASSETS: '/app/t/:tenantId/manage/assets',
  MANAGE_V2_ALERTS: '/app/t/:tenantId/manage/alerts',
  MANAGE_V2_MODEL_ALERTS: '/app/t/:tenantId/manage/models-alerts',
  MANAGE_V2_LIMITS: '/app/t/:tenantId/manage/limits',
  MANAGE_V2_WEBHOOKS: '/app/t/:tenantId/manage/webhooks',
  MANAGE_V2_OP_MODES: '/app/t/:tenantId/manage/op-modes',
  MANAGE_V2_USERS: '/app/t/:tenantId/manage/users',
  NOT_FOUND: '*',
};

export const QueryParams = {
  AUTH0: 'auth0',
  TRIAL_UPLOAD: 'trial-upload',
  UPLOAD: 'upload',
  INVITE: 'invite',
  TERMS_CONDITIONS: 'terms-conditions',
  PRIVACY_POLICY: 'privacy-policy',
  CONFIRM_EMAIL: 'confirm-email',
  ROLE: 'role',
};
